exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".avatar-and-name[data-v-4c1dc1f6] {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n}", ""]);

// exports
